import type { TranslationDataObj } from './type';

export const data: TranslationDataObj = {
  global: {
    you: {
      en: 'you',
      fr: 'toi',
    },
    loadingWorkspace: {
      en: 'Loading your blym workspace...',
      fr: 'Chargement de votre espace blym',
    },
    draft: {
      en: 'Draft',
      fr: 'Brouillon',
    },
    stop: {
      en: 'Stop',
      fr: 'Arrêter',
    },
    delete: {
      en: 'Delete',
      fr: 'Supprimer',
    },
    save: {
      en: 'Save',
      fr: 'Enregistrer',
    },
    dontSave: {
      en: "Don't save",
      fr: 'Ne pas enregistrer',
    },
    close: {
      en: 'Close',
      fr: 'Fermer',
    },
    country: {
      en: 'Country',
      fr: 'Pays',
    },
    defaultCountry: {
      en: 'Default country',
      fr: 'Pays par défaut',
    },
    defaultLanguage: {
      en: 'Default language',
      fr: 'Langue par défaut',
    },
    back: {
      en: 'Back',
      fr: 'Retour',
    },
    backToSignIn: {
      en: 'Back to sign in',
      fr: 'Retour au sign in',
    },
    language: {
      en: 'Language',
      fr: 'Langue',
    },
    loading: {
      en: 'Loading',
      fr: 'Chargement',
    },
    next: {
      en: 'Next',
      fr: 'Suivant',
    },
    skip: {
      en: 'Skip',
      fr: 'Passer',
    },
    add: {
      en: 'Add',
      fr: 'Ajouter',
    },
    noResults: {
      en: 'No results found',
      fr: 'Aucun résultat trouvé',
    },
    create: {
      en: 'Create',
      fr: 'Créer',
    },
    edit: {
      en: 'Edit',
      fr: 'Modifier',
    },
    preview: {
      en: 'Preview',
      fr: 'Aperçu',
    },
    cancel: {
      en: 'Cancel',
      fr: 'Annuler',
    },
    remove: {
      en: 'Remove',
      fr: 'Supprimer',
    },
    copy: {
      en: 'Copy',
      fr: 'Copie',
    },
    duplicate: {
      en: 'Duplicate',
      fr: 'Dupliquer',
    },
    firstName: {
      en: 'First name',
      fr: 'Prénom',
    },
    lastName: {
      en: 'Last name',
      fr: 'Nom de famille',
    },
    email: {
      en: 'Email',
      fr: 'Email',
    },
    password: {
      en: 'Password',
      fr: 'Mot de passe',
    },
    updated: {
      en: 'Updated',
      fr: 'Mis à jour',
    },
    created: {
      en: 'Created',
      fr: 'Créé',
    },
    saved: {
      en: 'Saved',
      fr: 'Enregistré',
    },
    continue: {
      en: 'Continue',
      fr: 'Continuer',
    },
    backToDashboard: {
      en: 'Back to dashboard',
      fr: 'Retour au tableau de bord',
    },
    didntReceiveEmail: {
      en: "You didn't receive an email?",
      fr: "Vous n'avez pas reçu d'e-mail?",
    },
    tryAgain: {
      en: 'Try again',
      fr: 'Réessayer',
    },
    secondsAgo: {
      en: '{{val, relativetime(second)}}',
      fr: '{{val, relativetime(second)}}',
    },
    minutesAgo: {
      en: '{{val, relativetime(minute)}}',
      fr: '{{val, relativetime(minute)}}',
    },
    hoursAgo: {
      en: '{{val, relativetime(hour)}}',
      fr: '{{val, relativetime(hour)}}',
    },
    daysAgo: {
      en: '{{val, relativetime(day)}}',
      fr: '{{val, relativetime(day)}}',
    },
    weeksAgo: {
      en: '{{val, relativetime(week)}}',
      fr: '{{val, relativetime(week)}}',
    },
    monthsAgo: {
      en: '{{val, relativetime(month)}}',
      fr: '{{val, relativetime(month)}}',
    },
    aLongTimeAgo: {
      en: 'a long time ago',
      fr: 'il y a longtemps',
    },
    copyToClipboard: {
      en: 'Copy to clipboard',
      fr: 'Copier dans le presse-papiers',
    },
    copiedToClipboard: {
      en: 'Copied to clipboard',
      fr: 'Copié dans le presse-papiers',
    },
    clipboardError: {
      en: 'Failed to copy',
      fr: 'Échec de la copie',
    },
    clipboardErrorDescription: {
      en: 'Failed to copy to clipboard. Please try again.',
      fr: 'Impossible de copier dans le presse-papiers. Veuillez réessayer.',
    },
    or: {
      en: 'or',
      fr: 'ou',
    },
    german: {
      en: 'German',
      fr: 'Allemand',
    },
    english: {
      en: 'English',
      fr: 'Anglais',
    },
    dutch: {
      en: 'Dutch',
      fr: 'Néerlandais',
    },
    swedish: {
      en: 'Swedish',
      fr: 'Suédois',
    },
    norwegianBokmal: {
      en: 'Norwegian Bokmal',
      fr: 'Norvégien Bokmal',
    },
    spanish: {
      en: 'Spanish',
      fr: 'Espagnol',
    },
    portuguesePt: {
      en: 'Portuguese (Portugal)',
      fr: 'Portugais (Portugal)',
    },
    portugueseBr: {
      en: 'Portuguese (Brazil)',
      fr: 'Portugais (Brésil)',
    },
    danish: {
      en: 'Danish',
      fr: 'Danois',
    },
    finnish: {
      en: 'Finnish',
      fr: 'Finnois',
    },
    polish: {
      en: 'Polish',
      fr: 'Polonais',
    },
    romanian: {
      en: 'Romanian',
      fr: 'Roumain',
    },
    french: {
      en: 'French',
      fr: 'Français',
    },
    italian: {
      en: 'Italian',
      fr: 'Italien',
    },
    portuguese: {
      en: 'Portuguese',
      fr: 'Portugais',
    },
    type: {
      en: 'Type',
      fr: 'Type',
    },
    article: {
      en: 'Content',
      fr: 'Contenu',
    },
    product: {
      en: 'Product',
      fr: 'Produit',
    },
    collection: {
      en: 'Collection',
      fr: 'Collection',
    },
    generateArticle: {
      en: 'Generate content',
      fr: 'Générer un contenu',
    },
    settings: {
      en: 'Settings',
      fr: 'Paramètres',
    },
    getHelp: {
      en: 'Help center',
      fr: `Centre d'aide`,
    },
    saveChanges: {
      en: 'Save changes',
      fr: 'Enregistrer les modifications',
    },
    eCommerce: {
      en: 'E-commerce',
      fr: 'E-commerce',
    },
    seoAgency: {
      en: 'SEO Agency / Consultant',
      fr: 'Agence / Consultant SEO',
    },
    otherServices: {
      en: 'Other services',
      fr: 'Autres services',
    },
    saasTech: {
      en: 'SaaS / Startup',
      fr: 'SaaS / Startup',
    },
    confirm: {
      en: 'Confirm',
      fr: 'Confirmer',
    },
    goToDashboard: {
      en: 'Go to dashboard',
      fr: 'Aller au tableau de bord',
    },

    // CANCEL FLOW
    cancelReasonPlaceholder: {
      en: 'Select a reason',
      fr: 'Sélectionner un motif',
    },
    cancelFlowError1: {
      en: 'Please select a reason',
      fr: 'Veuillez sélectionner un motif',
    },
    customerService: {
      en: 'Customer service was less than expected',
      fr: "Le service client n'était pas à la hauteur",
    },
    lowQuality: {
      en: 'Quality was less than expected',
      fr: 'La qualité était moins que prévue',
    },
    missingFeatures: {
      en: 'Some features are missing',
      fr: 'Certaines fonctionnalités sont manquantes',
    },
    unused: {
      en: "I don't use the service enough",
      fr: "Je n'utilise pas le service assez",
    },
    switchedService: {
      en: "I'm switching to a different service",
      fr: 'Je change pour un autre service',
    },
    tooComplex: {
      en: 'Ease of use was less than expected',
      fr: "L'utilisation était moins que prévue",
    },
    other: {
      en: 'Other',
      fr: 'Autre',
    },
    extraInformationLabel: {
      en: 'Provide more details',
      fr: 'Fournir plus de détails',
    },
    extraInformationPlaceholder: {
      en: 'Add details',
      fr: 'Ajouter des détails',
    },
    contactSupport: {
      en: 'Contact support',
      fr: 'Nous contacter',
    },
    keepAccess: {
      en: 'Keep my access',
      fr: 'Conserver mon accès',
    },

    select: {
      en: 'Select',
      fr: 'Sélectionner',
    },
    ok: {
      en: 'Ok',
      fr: 'Ok',
    },
    logout: {
      en: 'Sign out',
      fr: 'Déconnexion',
    },
    confirmSignOut: {
      en: 'Are you sure you want to sign out?',
      fr: 'Êtes-vous sûr de vouloir vous déconnecter ?',
    },
    nevermind: {
      en: 'Nevermind',
      fr: 'Rester connecté',
    },
    somethingWentWrong: {
      en: 'Something went wrong, please try again or contact support',
      fr: "Quelque chose s'est mal passé, veuillez réessayer ou contacter le support",
    },
    badRequest: {
      en: 'Invalid request. Please check your input and try again.',
      fr: 'Requête invalide. Veuillez vérifier vos informations et réessayer.',
    },
    metaTitleDashboard: {
      en: 'Dashboard',
      fr: 'Tableau de bord',
    },
    metaTitleBrandContext: {
      en: 'Brand context',
      fr: 'Brand context',
    },
    metaTitleEditor: {
      en: 'Editor',
      fr: 'Éditeur',
    },
    metaTitleFunnel: {
      en: 'Funnel',
      fr: 'Tunnel',
    },
    metaTitleFunnelAddExtraInfo: {
      en: 'Add extra information',
      fr: 'Ajouter des informations',
    },
    metaTitleFunnelChooseTitle: {
      en: 'Choose a title',
      fr: 'Choisir un titre',
    },
    metaTitleFunnelChooseOutline: {
      en: 'Choose an outline',
      fr: 'Choisir un plan',
    },
    metaTitleFunnelAddContent: {
      en: 'Add content',
      fr: 'Ajouter du contenu',
    },
    metaTitleAuth: {
      en: 'Authentication',
      fr: 'Authentification',
    },
    metaTitleSignUp: {
      en: 'Sign up',
      fr: 'Inscription',
    },
    metaTitleSignIn: {
      en: 'Sign in',
      fr: 'Connexion',
    },
    metaDescriptionSignUp: {
      en: 'Sign up for Blym and start creating high-quality SEO content with AI-assisted writing.',
      fr: "Inscrivez-vous à Blym et commencez à créer du contenu SEO de haute qualité avec l'écriture assistée par IA.",
    },
    metaDescriptionSignIn: {
      en: 'Log in to your Blym account to manage your AI-assisted blog content.',
      fr: 'Connectez-vous à votre compte Blym pour gérer votre contenu de blog assisté par IA.',
    },
    metaDescriptionDemo: {
      en: 'Book a live demo of Blym and discover how AI-assisted writing can grow your blog.',
      fr: "Réservez une démo en direct de Blym et découvrez comment l'écriture assistée par IA peut faire croître votre blog.",
    },
    metaTitleSettings: {
      en: 'Settings',
      fr: 'Paramètres',
    },
    metaTitleSettingsBilling: {
      en: 'Billing – Settings',
      fr: 'Facturation – Paramètres',
    },
    metaTitleSettingsCredits: {
      en: 'Credits – Settings',
      fr: 'Crédits – Paramètres',
    },
    metaTitleSettingsUsers: {
      en: 'Users – Settings',
      fr: 'Utilisateurs – Paramètres',
    },
    metaTitleSettingsBrands: {
      en: 'Brands – Settings',
      fr: 'Marques – Paramètres',
    },
    metaTitleSettingsProfile: {
      en: 'Profile – Settings',
      fr: 'Profil – Paramètres',
    },
    accept: {
      en: 'Accept',
      fr: 'Accepter',
    },
    decline: {
      en: 'Decline',
      fr: 'Refuser',
    },
    noCreditsLeft: {
      en: 'No trial credits left.',
      fr: "Vous n'avez plus de crédits d'essai.",
    },
    subscribeToAPlan: {
      en: 'Subscribe to create without limitations.',
      fr: 'Souscrire à un plan pour créer sans limites.',
    },
    choosePlan: {
      en: 'Choose a plan',
      fr: 'Choisir un plan',
    },
    dropFileHereToUpload: {
      en: 'Drop a file here to upload',
      fr: 'Déposez un fichier ici pour télécharger',
    },
    dropFilesHereToUpload: {
      en: 'Select or drop a CSV file to import',
      fr: 'Sélectionnez ou déposez un fichier CSV à importer',
    },
    uploadFile: {
      en: 'Upload file',
      fr: 'Télécharger un fichier',
    },
    selectACountry: {
      en: 'Select a country',
      fr: 'Sélectionner un pays',
    },
    selectALanguage: {
      en: 'Select a language',
      fr: 'Sélectionner une langue',
    },

    optional: {
      en: '(optional)',
      fr: '(optionnel)',
    },
    generate: {
      en: 'Generate',
      fr: 'Générer',
    },
    // eslint-disable-next-line camelcase
    field_one: {
      en: '{{count}} field',
      fr: '{{count}} champ',
    },
    // eslint-disable-next-line camelcase
    field_other: {
      en: '{{count}} fields',
      fr: '{{count}} champs',
    },
    mbMax: {
      en: '{{count}} MB max',
      fr: '{{count}} MB max',
    },
    export: {
      en: 'Export',
      fr: 'Exporter',
    },
    search: {
      en: 'Search',
      fr: 'Rechercher',
    },
    searchProducts: {
      en: 'Search products',
      fr: 'Rechercher des produits',
    },
    sortBy: {
      en: 'Sort by',
      fr: 'Trier par',
    },
    mostRecent: {
      en: 'Most recent',
      fr: 'Les plus récents',
    },
    oldestFirst: {
      en: 'Oldest first',
      fr: 'Les plus anciens en premier',
    },
    wordLimit: {
      en: 'Word limit',
      fr: 'Limite de mots',
    },
    words: {
      en: 'words',
      fr: 'mots',
    },
    upgradePlan: {
      en: 'Upgrade plan',
      fr: "Mettre à niveau l'abonnement",
    },
    metaTitleDemo: {
      en: 'Book a demo',
      fr: 'Réserver une démo',
    },
    metaTitleBlogDashboard: {
      en: 'Blog Dashboard',
      fr: 'Tableau de bord Blog',
    },
    metaTitleProductDashboard: {
      en: 'Product Dashboard',
      fr: 'Tableau de bord Produit',
    },
    metaTitleBulkImports: {
      en: 'Bulk Imports',
      fr: 'Importations en groupe',
    },
    metaTitleProductTemplates: {
      en: 'Product templates',
      fr: 'Templates de produit',
    },
    metaTitleNewProductTemplate: {
      en: 'New Product Template',
      fr: 'Nouveau template de produit',
    },
    funnel: {
      en: 'Funnel',
      fr: 'Tunnel',
    },
    retry: {
      en: 'Retry',
      fr: 'Réessayer',
    },
    goBack: {
      en: 'Go back',
      fr: 'Retour',
    },
    languageTooltip: {
      en: 'Language',
      fr: 'Langue',
    },
    descLanguageTooltip: {
      en: 'Choose the language for the generated content',
      fr: 'Choisissez la langue pour le contenu généré',
    },
    countryTooltip: {
      en: 'Country',
      fr: 'Pays',
    },
    descCountryTooltip: {
      en: 'Choose the country your content targets',
      fr: 'Choisissez le pays de votre contenu',
    },
    comingSoon: {
      en: 'Coming soon',
      fr: 'À venir',
    },
    stepOf: {
      en: '{{current}} of {{total}}',
      fr: '{{current}} sur {{total}}',
    },
    beta: {
      en: 'Beta',
      fr: 'Beta',
    },
    newHere: {
      en: 'New here?',
      fr: 'Nouveau ici ?',
    },
    seeHowItWorks: {
      en: 'See how it works',
      fr: 'Voir comment ça marche',
    },
  },
};
